
import React, { memo } from 'react';

interface EmailPageLayoutProps {
  children: React.ReactNode;
}

export const EmailPageLayout = memo(function EmailPageLayout({ children }: EmailPageLayoutProps) {
  return (
    <div className="p-4 w-full overflow-visible">
      <div 
        className="email-content-wrapper bg-background mx-auto"
        style={{ 
          width: '100%',
          maxWidth: '1200px',
          minHeight: '600px',
          position: 'relative',
          contain: 'layout style',
          display: 'flex',
          flexDirection: 'column',
          margin: '0 auto',
          overflow: 'visible',
          // GPU acceleration and paint containment
          transform: 'translateZ(0)',
          willChange: 'opacity',
          transition: 'opacity 0.3s ease-in-out',
        }}
      >
        {children}
      </div>
    </div>
  );
});
